import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const timekeeperLocaleModule: LocaleModule = {
  name: "timekeeper",
  messages: { en: en, it: it },
};
